import { Contact } from "../../Components/Contact"
import { Footer } from "../../Components/Footer"
import { Header } from "../../Components/Header"


export const ContactUs = () => {

    return (
        <>
        <Header />
        <Contact />
        <Footer />
        </>
        
    )
}